// extracted by mini-css-extract-plugin
module.exports = {"InstructionItem":"AvailabilityInstructions_InstructionItem__3Os2W","ItemNumber":"AvailabilityInstructions_ItemNumber__1_JZh"};